import CustomIcon from "@/components/ui/custom-icon";
import S from "./index.module.scss";
import { observer } from "mobx-react-lite";
import { useStore } from "@/hooks/system/useStore";
import { useState } from "react";

const AddressesInput = () => {
  const [value, setValue] = useState<string>("");
  const { query, setQuery } = useStore("addresses");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (value.trim()) {
      setQuery(value.trim());
    }
  };

  const handleClear = () => {
    setValue("");
    setQuery("");
  };

  return (
    <form onSubmit={handleSubmit} className={S.wrapper}>
      <input
        className={S.input}
        value={value}
        onChange={e => setValue(e.target.value)}
        type="text"
        placeholder="Stadt, Land"
      />
      <CustomIcon fileName="icon-search-black" className={S.icon} />
      {query && (
        <span className={S.close} onClick={handleClear}>
          <CustomIcon fileName="icon-close" />
        </span>
      )}
      <button className={S.button} type="submit">
        <CustomIcon fileName="nav-icon" />
      </button>
    </form>
  );
};

export default observer(AddressesInput);
